import { ATTRS, TAGS } from '../constants';
import { EntitiesManager } from '../entitiesManager';
import { Entity } from '../types';
import { ProcessDataVariableEntity } from './ProcessDataVariable';

export class TreatmentZoneEntity implements Entity {
  public static fromXML(xml, matchIDs, files, entitiesManager: EntitiesManager) {
    const attrs = xml._attributes;
    return {
      entity: new TreatmentZoneEntity(
        attrs[ATTRS.TreatmentZone.TreatmentZoneCode],
        (xml[TAGS.ProcessDataVariable] || []).map((pdv) =>
          ProcessDataVariableEntity.fromXML(pdv, matchIDs, files, entitiesManager)
        ),
        attrs[ATTRS.TreatmentZone.TreatmentZoneDesignator],
        attrs[ATTRS.TreatmentZone.TreatmentZoneColour]
      ),
    };
  }
  public type = TAGS.TreatmentZone;

  constructor(
    public code: number,
    public processDataVariables: ProcessDataVariableEntity[],
    private designator?: string,
    private color?: number
  ) {}

  public toXML(xmlId: string, entityManager: EntitiesManager) {
    return {
      _attributes: {
        [ATTRS.TreatmentZone.TreatmentZoneCode]: this.code,
        ...(this.designator && { [ATTRS.TreatmentZone.TreatmentZoneDesignator]: this.designator }),
        ...(this.color && { [ATTRS.TreatmentZone.TreatmentZoneColour]: this.color }),
      },
      [TAGS.ProcessDataVariable]: this.processDataVariables.map((pdv) =>
        pdv.toXML(null, entityManager)
      ),
    };
  }
}
